import axios from "./axios";

const getHeaders = (token) => ({
  headers: {
    "API-TOKEN": token,
  },
});

export const getUsers = (token, query = "") => {
  return axios.get("/users", {
    headers: { "API-TOKEN": token },
    params: { query },
  });
};

export const getUser = (token) => {
  return axios.get("/profile", getHeaders(token));
};

export const getCompany = (token) => {
  return axios.get("/company-info", getHeaders(token));
};

export const saveProfile = (token, profileData, companyData) => {
  return axios.post(
    "/profile/save",
    {
      profile: profileData,
      company: companyData,
    },
    getHeaders(token)
  );
};

export const resetPassword = (token) => {
  return axios.post("/update-pass", {}, getHeaders(token));
};

export const checkAuthentication = (token) => {
  return axios.get("/auth0-check", getHeaders(token));
};

export const checkVerification = (token) => {
  return axios.get("/auth0/check-email-verification", getHeaders(token));
};

export const resetUserPassword = (token, id) => {
  return axios.get("/user-reset/" + id, getHeaders(token));
};

export const deleteUser = (token, id) => {
  return axios.get("/user-delete/" + id, getHeaders(token));
};

export const editUser = (token, id, data) => {
  return axios.post(`/user/edit/${id}`, data, getHeaders(token));
};

export const addUser = (token, name, email) => {
  return axios.get("/admin-add-user", {
    headers: { "API-TOKEN": token },
    params: { name, email },
  });
};

export const setNotificationPreferences = (
  token,
  notification_type_id,
  status
) => {
  return axios.post(
    "/user/setNotificationPreferences",
    { notification_type_id, status },
    getHeaders(token)
  );
};

export const getNotificationPreferences = (token) => {
  return axios.get("/user/getNotificationPreferences", getHeaders(token));
};

export const uploadUserProfilePic = (token, pictureFile) => {
  const formData = new FormData();
  formData.append("picture", pictureFile);

  return axios.post("/user/picture", formData, {
    headers: {
      "API-TOKEN": token,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const closeAccount = (token) => {
  return axios.get("/user/close-account", getHeaders(token));
};

export const getRestoreDemoVideo = (token) => {
  return axios.get("/user/get-restore-demo-video", getHeaders(token));
};

export const submitReferral = (token, code) => {
  return axios.get("/user/redeem-referral-code/" + code, getHeaders(token));
};

export const checkPayrollAvailability = (token, organizationId, backupDate) => {
  return axios.get(`/check-payroll/${organizationId}`, {
    headers: { "API-TOKEN": token },
    params: { backup_date: backupDate },
  });
};

export const getXeroEmployees = (token, organizationId, backupDate) => {
  return axios.get(`/xero/employees/${organizationId}/backup/${backupDate}`, getHeaders(token));
};

export const uploadEmployeeCSV = (token, formData) => {
  return axios.post("/upload-employee-csv", formData, {
    headers: {
      "API-TOKEN": token,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getResellers = (token, query = "") => {
  return axios.get("/reseller/list", {
    headers: { "API-TOKEN": token },
    params: { query },
  });
};

export const addReseller = (token, full_name, email, referral_fee_percent) => {
  return axios.post(
    "/reseller/add",
    { full_name, email, referral_fee_percent },
    getHeaders(token)
  );
};

export const updateResellerStatus = (token, resellerId, status) => {
  return axios.get("reseller/update-status/" + resellerId + "/" + status, getHeaders(token));
};

export const getResellerUsers = (token, resellerId) => {
  return axios.get("/reseller/users/" + resellerId, getHeaders(token));
};

export const getMyResellerCustomers = (token) => {
  return axios.get("/reseller/my-customers", getHeaders(token));
};

export const blockUser = (token, userId, reason = "") => {
  return axios.post(
    `/user/block/${userId}`,
    { reason },
    getHeaders(token)
  );
};

export const unblockUser = (token, userId) => {
  return axios.post(
    `/user/unblock/${userId}`,
    {},
    getHeaders(token)
  );
};

export const exportUsers = (token) => {
  return axios.get("/users/export", {
    headers: { "API-TOKEN": token },
    responseType: "blob",
  });
};

export const getAdminUserEmails = (token, userId) => {
  return axios.get(`/admin/user-emails/${userId}`, getHeaders(token));
};

export const toggleUserResellerRole = (token, userId) => {
  return axios.post(`/user/toggle-reseller/${userId}`, {}, getHeaders(token));
};

export const getResellerInviteInfo = (referralCode) => {
  return axios.get(`/user/reseller-invite-info/${referralCode}`);
};

export const getMonthlyBackupRestoreReport = (token, month = "") => {
  return axios.get("/user/monthly-backup-restore-report", {
    headers: { "API-TOKEN": token },
    params: { month },
  });
};

export const getOrganizationMonthlyReport = (token, orgId, platform = "xero", month = "") => {
  return axios.get("/user/organization-monthly-report", {
    headers: { "API-TOKEN": token },
    params: { org_id: orgId, platform, month },
  });
};

export const sendResellerCustomerInvite = (token, payload) => {
  return axios.post("/user/send-reseller-customer-invite", payload, getHeaders(token));
};


